import { useEffect, useMemo, useState } from 'react'
import { Text } from '@leroy-merlin-br/backyard-react'

import emitter from 'scripts/utils/emitter'

import { LogoInstala } from 'catalog/pages/NewProduct/images'
import { getProductServices } from 'catalog/services/product-services'
import type { ProductService } from 'catalog/services/product-services'

import * as S from './styled'

interface ServiceLabelProps {
  productId: number
  regionId: string
  isServicesEnabled?: boolean
  hasCrossServices?: boolean
  shopName?: string
}

const LEROY_STORE_SHOP_NAME = 'Leroy Merlin'

const ServiceLabel = (props: ServiceLabelProps) => {
  const { productId, regionId, shopName, hasCrossServices, isServicesEnabled } =
    props
  const [services, setServices] = useState<ProductService[]>()
  const [isLeroyStore, setIsLeroyStore] = useState(
    shopName === LEROY_STORE_SHOP_NAME
  )

  const shouldRenderCrossServicesBadge = useMemo(
    () =>
      isServicesEnabled && hasCrossServices && isLeroyStore,
    [isLeroyStore, hasCrossServices, isServicesEnabled]
  )

  useEffect(() => {
    if (shouldRenderCrossServicesBadge && !services) {
      const fetchProductServices = async () => {
        const data = await getProductServices(productId, regionId)
        setServices(data)
      }

      fetchProductServices()
    }
  }, [productId, regionId, shouldRenderCrossServicesBadge, services])

  useEffect(() => {
    emitter.on('buybox:sellerChange', data => {
      if (data?.shopName) {
        setIsLeroyStore(data.shopName === LEROY_STORE_SHOP_NAME)
      }
    })
  }, [])

  if (!shouldRenderCrossServicesBadge || !services) {
    return null
  }

  const servicePrice = parseFloat(`${services[0].price.to}`)

  return (
    <S.Wrapper>
      <S.Logo>
        <LogoInstala />
      </S.Logo>

      <div>
        <Text as="p" size="mega" noMargin isBold>
          Instalamos para você!
        </Text>
        <Text as="p" size="kilo" noMargin>
          Consulte o preço ao adicionar no carrinho
        </Text>
        <S.HiddenPrice>{servicePrice}</S.HiddenPrice>
      </div>
    </S.Wrapper>
  )
}

export default ServiceLabel
